import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import {
    AccountLeads,
    ActivityDialogStore,
    ActivityHistoryDialogStore,
    CompanyDialogStore,
    HistoryDetailsDialogStore,
    Lead,
    LeadScreenStore,
    SprintDialogStore,
    ViewType,
} from '../../../stores/LeadStore';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Grid from '@mui/material/Grid';
import DoActivityLeadInformation from './DoActivityLeadInformation';
import { LeadDataFormater } from 'src/features/leads/view/LeadDataFormater';
import { LeadAccountComponent } from 'src/features/leads/view/LeadAccountComponent';
import LeadForm from './LeadForm';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box, { BoxProps } from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import Close from 'mdi-material-ui/Close';
import { v4 as uuidv4 } from 'uuid';
import { client } from 'src/utils/axios-client';
import { ProblemDetails } from 'src/types/ApiErrorResponse';
import { Button, IconButton, Tooltip } from '@mui/material';
import { useEffect } from 'react';
import { getLeadEndpoint, leadEndpoints } from 'src/configs/endpoints';
import { LeadListStore } from 'src/stores/LeadStore';
import _ from 'lodash';
import Paper, { PaperProps } from '@mui/material/Paper';
import paper from '../../../materio/@core/theme/overrides/paper';
import AccountLeadList from './AccountLeadList';
import ActivityHistoryList from './ActivityHistoryList';
import DoActivityDetails from './DoActivityDetails';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title: string;
};

export default function DoActivitySecondaryDialog({ open, onConfirm, onCancel, title }: Props) {
    const historyDetailsDialogStore = HistoryDetailsDialogStore.useState((s) => s.historyDetailsDialogStore);

    return (
        <Dialog
            fullWidth={true}
            maxWidth="lg"
            open={open}
            onClose={onCancel}
            scroll="body"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle>
                <Box
                    className="customizer-header"
                    sx={{
                        position: 'relative',
                        p: (theme) => theme.spacing(3.5, 5),
                        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                    }}
                >
                    <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
                    <IconButton
                        data-testid="close-button"
                        onClick={onCancel}
                        sx={{
                            right: 20,
                            top: '50%',
                            position: 'absolute',
                            color: 'text.secondary',
                            transform: 'translateY(-50%)',
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <PerfectScrollbar options={{ wheelPropagation: false }}>
                    {historyDetailsDialogStore && <DoActivityDetails />}
                </PerfectScrollbar>
            </DialogContent>
        </Dialog>
    );
}
